import { useEffect } from 'react'
import api from '../lib/api'

export function useEmailArrival(
  demandId: string | number | null | undefined,
  source: string | null,
) {
  useEffect(() => {
    if (source !== 'email' || !demandId) return
    // Measurement must not block opening the request or changing its status.
    void api.post(`/notifications/email-arrival/${demandId}`).catch(() => {
      console.warn('Could not record email arrival')
    })
  }, [demandId, source])
}
